'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import Banner from '@/components/Banner';
import icon from '@/public/icons/ssosBannerIcon.svg';

type SsosBannerProps = {
  className?: string;
};

export default function SsosBanner({ className }: SsosBannerProps) {
  const t = useTranslations('ssos-banner');
  const [displayed, setDisplayed] = useState(true);

  if (!displayed) {
    return null;
  }

  return (
    <Banner
      className={className}
      description={t('description')}
      title={t('title')}
      testId="ssos"
      icon={icon}
      onClose={() => setDisplayed(false)}
    />
  );
}
